export class Step7 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step6';
    getgaranties = 'form.mapa_in.getgaranties';
    getmodfinancement = 'form.mapa_in.getmodfinancement';
    geteuro = 'form.mapa_in.geteuro';
    getformejuridique = 'form.mapa_in.getformejuridique';
    getlangec = 'form.mapa_in.getlangec_liste_avi_';
    getlangautre = 'form.mapa_in.getlangautre';
    getlanguefr = 'form.mapa_in.getlanguefr';
    getspan7 = 'form.mapa_in.getspan7';
    getautresconditionsoui = 'form.mapa_in.getautresconditionsoui';
    getautresconditionsnon = 'form.mapa_in.getautresconditionsnon';
    getspan8 = 'form.mapa_in.getspan8';
    getspan9 = 'form.mapa_in.getspan9';
    getspan10 = 'form.mapa_in.getspan10';

}
